import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ComponentContextComponent, StateManager } from './ComponentContext';
import App from './App';

declare global {
  interface Window {
    initPlugin: (id: string) => void;
  }
}

const initState = { field1: 'test' };
export type ComponentStateType = typeof initState;

window.initPlugin = (id: string) => {
  const root = ReactDOM.createRoot(document.getElementById(id) as HTMLElement);
  const stateManager = new StateManager(initState);

  root.render(
    <React.StrictMode>
      <ComponentContextComponent stateManager={stateManager}>
        <App />
      </ComponentContextComponent>
    </React.StrictMode>
  );
};

if (process.env.NODE_ENV === 'development') {
  window.initPlugin('root');
}
